import { useEffect, useState } from 'react';

// const baseUrl = "http://localhost:3001" //DEV
const baseUrl = 'https://cwc-backend-heroku.herokuapp.com'; //PRODUCTION

const useDeleteImage = (token, imgName, upc) => {
	const [errorDeleteImg, setErrorDeleteImg] = useState(null);
	const [loadingDeleteImage, setLoadingDeleteImage] = useState(false);
	const [imageToDelete, setImageToDelete] = useState(null);

	const deleteImage = async (imgName, upc, fetchImgData) => {
		//check that is an image, or at least a File obj or trhow err
		if (!imgName) {
			return;
		}

		//reset the data and loading
		setLoadingDeleteImage(true);

		const options = {
			method: 'DELETE',
			headers: {
				Authorization: `Bearer ${token}`,
			},
		};
		const url = `${baseUrl}/inventory/images/delete/${imgName}`;
		try {
			const response = await fetch(url, options);
			const parsedResponse = await response.json();
			console.log('RESPONSE FROM FILE DELETE', parsedResponse);

			if (parsedResponse.success === true) {
				//all good! image deleted from s3!
				fetchImgData(upc);
				setLoadingDeleteImage(false);
			}

			//parse the confirmation
		} catch (errorImgDelete) {
			setErrorDeleteImg(errorImgDelete);
			setLoadingDeleteImage(false);
			return console.error(errorImgDelete);
		}
	};

	useEffect(() => {
		if (!token || !imgName) return;

		deleteImage(upc, imgName);
	}, [token, upc, imgName]);

	return { errorDeleteImg, loadingDeleteImage, imageToDelete, deleteImage };
};

export default useDeleteImage;
